<template>
    <div>
        <div class="row-12 d-flex justify-content-center mb-3">
            <label v-if="!inputFileLabel" for="formFile" class="label-file font-button-modified">
                <i class="fa fa-cloud-upload fa-lg" aria-hidden="true"></i>
                Escolha um arquivo
            </label>
            <label v-else for="formFile" class="label-file font-button-modified">{{ inputFileLabel }}</label>
            <input class="form-control d-none" type="file" id="formFile" @change="getFile" accept=".json">
        </div>
        <div v-if="aulas.length > 0" class="row row-12 d-flex justify-content-center mb-3">
            <div class="col-sm-12" v-for="(aula, index) in aulas" :key="index">
                <vuestic-accordion>
                    <vuestic-collapse>
                        <span slot="header"> Aula {{ index + 1}}</span>
                        <div class="container" slot="body">
                            <div class="row col-sm-12 justify-content-center">
                                <div style="padding: 10px;" class="col-sm-6">
                                    <div>
                                        <h4>Detalhes</h4>
                                        <hr>
                                        <div style="padding: 10px;">
                                            <span><h5>Horário da aula</h5></span>
                                            <hr>
                                            <div class="form-group row" style="padding: 20px;">
                                                <div class="col-sm-6">
                                                    <label>Inicio da aula:</label>
                                                    <span class="form-control" :class="statusColor(aula.details.begin_time)">{{ aula.details.begin_time }}</span>
                                                </div>
                                                <div class="col-sm-6">
                                                    <label>Fim da aula:</label> <br>
                                                    <span v-once v-show="aula.details.finish_time != ''"
                                                        class="form-control" :class="statusColor(aula.details.finish_time)">
                                                        {{ aula.details.finish_time }}
                                                    </span>
                                                    <input v-once v-show="!(aula.details.finish_time != '')" type="time"
                                                        @change="aula.details.finish_time = updateHour($event, aula.details.finish_time)"
                                                        class="form-control" :class="statusColor(aula.details.finish_time)">
                                                </div>
                                            </div>
                                            <span><h5>Hodômetro</h5></span>
                                            <hr>
                                            <div class="form-group row" style="padding: 20px;">
                                                <div class="col-sm-6">
                                                    <label>Hodômetro inicial:</label>
                                                    <span class="form-control" :class="statusColor(aula.details.hodo_start)">{{ aula.details.hodo_start }}</span>
                                                </div>
                                                <div class="col-sm-6">
                                                    <label>Hodômetro final:</label>
                                                    <span v-once v-show="aula.details.hodo_end !== '' && aula.details.hodo_end != 0"
                                                    class="form-control" :class="statusColor(aula.details.hodo_end)">
                                                        {{ aula.details.hodo_end }}
                                                    </span>
                                                    <input v-once v-show="!(aula.details.hodo_end !== '' && aula.details.hodo_end != 0)" type="number" id="hodo_end"
                                                        class="form-control" :class="statusColor(aula.details.hodo_end)" v-model="aula.details.hodo_end" value=''>
                                                </div>
                                            </div>
                                            <template v-if="aula.details.finish_reason !== ''">
                                                <div>
                                                    <span><h5>Motivo do encerramento da aula:</h5></span>
                                                    <span class="form-control">{{ aula.details.finish_reason }}</span>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <div style="padding: 10px;" class="col-sm-6">
                                    <div class="col-sm-12">
                                        <h4>Conteudos</h4>
                                        <!-- <template v-once v-show="(aula.contents.length > 0)">
                                            <div v-for="(conteudo, index) in aula.contents" :key="index">
                                                {{ index + 1 }} - <span>{{ conteudo.descricao }}</span>
                                            </div>
                                        </template> -->
                                        <div v-once v-show="aula.contents.length > 0">
                                            <div v-for="(conteudo, index) in aula.contents" :key="index">
                                            <br>
                                                {{ index + 1 }} - <span>{{ conteudo.descricao }}</span>
                                            </div>
                                        </div>
                                        <div v-once v-show="aula.contents.length < 1">
                                            <div>
                                                <select class="form-control" v-model="conteudosSelected" @change="aula.contents = getConteudosFiltrados(conteudosSelected)">
                                                    <option value=0 disabled>Selecione o conteúdo</option>
                                                    <option value=1>Conceitos Basicos</option>
                                                    <option value=2>Aprendendo a conduzir</option>
                                                    <option value=3>Aprendizado da circulação</option>
                                                    <option value=4>Condução segura</option>
                                                    <option value=5>Parada e estacionamento</option>
                                                </select>
                                                <div v-for="(conteudo, index) in aula.contents" :key="index">
                                                <br>
                                                    {{ index + 1 }} - <span>{{ conteudo.descricao }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="col-sm-12">
                                        <h4>GPS</h4>
                                        <span v-if="aula.gps.length > 2">GPS registrado!</span>
                                        <span v-else>Não alcançou a quantidade mínima de pontos de GPS registrados durante a aula</span>
                                    </div>
                                </div>
                                <hr>
                                <div style="padding: 10px;">
                                    <div class="col-sm-12">
                                        <h4>Fotos</h4>
                                        <div class="row" v-if="aula.photos.length > 0">
                                            <div class="col" v-for="(foto, index) in aula.photos" :key="index">
                                                <img class="col" :src="'data:image/jpg;base64, ' + foto.base64" :alt="foto.time_taken">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </vuestic-collapse>
                </vuestic-accordion>
            </div>
            <div class="footer" style="padding: 15px;">
                <button @click="setAula()" class="btn btn-block btn-lg btn-info">Enviar aulas</button>
            </div>
        </div>

        <div>
            <div v-for="message in messages" :key="message.index">
                <div class="row-12 d-flex justify-content-center mb-1 text-danger align-items-center" v-if="editFile">
                    <i class="fa fa-times mr-1" aria-hidden="true"></i>
                    <div class="message">{{ message }}</div>
                </div>
            </div>
            <div class="row-12 d-flex justify-content-center mb-1 text-success align-items-center" v-if="fileCorrect">
                <i class="fa fa-check mr-1" aria-hidden="true"></i>
                <div class="message">Tudo certo com a aula!</div>
            </div>
        </div>

        <div class="row-12 d-flex my-5">
            <div class="col-6" v-if="editFile || fileCorrect">
                <div class="row-12 d-flex">

                    <div class="col-6">
                        <div>
                            <fieldset class="mb-3">
                                <legend>Auto Escola</legend>
                                <model-select :options="autoescolas" v-model="selectedCFC"
                                    placeholder="Selecione uma autoescola"></model-select>
                            </fieldset>
                        </div>

                        <div v-if="editHodo">
                            <fieldset class="mb-3">
                                <legend>Hodômetro</legend>
                                <div class="d-flex">
                                    <input class="col-6 mr-1" type="number" placeholder="Inicial"
                                        v-model="hodometro.hodoStart" :disabled="hodometro.hodoStartDisabled">
                                    <input class="col-6" type="number" placeholder="Final" v-model="hodometro.hodoEnd"
                                        :disabled="hodometro.hodoEndDisabled">
                                </div>
                            </fieldset>
                        </div>
                    </div>

                    <div class="col-6">
                        <div v-if="editContents">
                            <fieldset class="mb-3">
                                <legend>Plano de Ensino</legend>
                                <model-select :options="selectContent" v-model="selectedContent"
                                    placeholder="Selecione um plano de ensino"></model-select>
                            </fieldset>
                        </div>

                        <div v-if="editTime">
                            <fieldset class="mb-3">
                                <div class="mb-3">
                                    <legend>Horário Início</legend>
                                    <the-mask class="col-8" :mask="'####-##-## ##:##:##'" masked
                                        placeholder="YYYY-MM-DD 00:00:00" v-model="time.begin"
                                        :disabled="time.beginDisabled" />
                                </div>
                                <div>
                                    <legend>Horário Fim</legend>
                                    <the-mask class="col-8" :mask="'####-##-## ##:##:##'" masked
                                        placeholder="YYYY-MM-DD 00:00:00" v-model="time.finish"
                                        :disabled="time.finishDisabled" />
                                </div>
                            </fieldset>
                        </div>
                    </div>

                </div>
            </div>

            <div class="col-6" v-if="editContents">
                <div class="row-12">
                    <!-- Conceitos Basicos -->
                    <div class="col-12" v-if="selectedContent == 1">
                        <fieldset>
                            <legend>Conteúdos</legend>
                            <div v-for="(conteudo, index) in conceitosBasicos" :key="index">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" :value="conteudo"
                                        id="flexCheckDefault" v-model="checkedContents">
                                    <label class="form-check-label" for="flexCheckDefault">
                                        {{ conteudo.descricao }}
                                    </label>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                    <!-- Aprendendo a conduzir -->
                    <div class="col-12" v-if="(selectedContent == 2)">
                        <fieldset>
                            <legend>Conteudos</legend>
                            <div v-for="(conteudo, index) in aprendendoAConduzir" :key="index">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" :value="conteudo"
                                        id="flexCheckDefault" v-model="checkedContents">
                                    <label class="form-check-label" for="flexCheckDefault">
                                        {{ conteudo.descricao }}
                                    </label>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                    <!-- Aprendizado da circulação -->
                    <div class="col-12" v-if="(selectedContent == 3)">
                        <fieldset>
                            <legend>Conteudos</legend>
                            <div v-for="(conteudo, index) in aprendizadoDaCirculacao" :key="index">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" :value="conteudo"
                                        id="flexCheckDefault" v-model="checkedContents">
                                    <label class="form-check-label" for="flexCheckDefault">
                                        {{ conteudo.descricao }}
                                    </label>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                    <!-- Condução segura -->
                    <div class="col-12" v-if="(selectedContent == 4)">
                        <fieldset>
                            <legend>Conteudos</legend>
                            <div v-for="(conteudo, index) in conducaoSegura" :key="index">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" :value="conteudo"
                                        id="flexCheckDefault" v-model="checkedContents">
                                    <label class="form-check-label" for="flexCheckDefault">
                                        {{ conteudo.descricao }}
                                    </label>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                    <!-- Parada e estacionamento -->
                    <div class="col-12" v-if="(selectedContent == 5)">
                        <fieldset>
                            <legend>Conteudos</legend>
                            <div v-for="(conteudo, index) in paradaEstacionamento" :key="index">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" :value="conteudo"
                                        id="flexCheckDefault" v-model="checkedContents">
                                    <label class="form-check-label" for="flexCheckDefault">
                                        {{ conteudo.descricao }}
                                    </label>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </div>
            </div>
        </div>

        <div class="row-12 d-flex justify-content-center mb-3" v-if="editFile || fileCorrect">
            <div class="col-md-3 text-right">
                <button class="btn btn-info col-12 btn-micro d-flex justify-content-center" @click="setData"
                    :disabled="sendData">
                    <component v-if="sendData" :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'"
                        :size="17"></component>
                    <span v-else class="font-button-modified">Salvar</span>
                </button>
            </div>
            <div class="col-md-3 text-right">
                <button class="btn btn-danger col-12 btn-micro d-flex justify-content-center" @click="clear"
                    :disabled="sendData">
                    <component v-if="sendData" :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'"
                        :size="17"></component>
                    <span v-else class="font-button-modified">Clear</span>
                </button>
            </div>
        </div>

    </div>
</template>

<script>
import urlApi from '@/router/urlApiV2'
import { ModelSelect } from 'vue-search-select'
import { TheMask } from 'vue-the-mask'
import * as spinners from 'epic-spinners'

export default {
    name: 'ModalUploadAula',
    components: {
        ModelSelect,
        TheMask,
        ...spinners,
    },
    props: {
        autoescolas: Array,
    },
    data() {
        return {
            hodometro: {
                hodoStart: '',
                hodoEnd: '',
                hodoStartDisabled: false,
                hodoEndDisabled: false,
            },

            time: {
                begin: '',
                finish: '',
                beginDisabled: false,
                finishDisabled: false,
            },

            inputFileLabel: '',
            dataInput: '',
            selectedCFC: '',
            selectedContent: '',

            messages: [],
            selectCFC: [],
            selectContent: [],
            conceitosBasicos: [],
            aprendendoAConduzir: [],
            aprendizadoDaCirculacao: [],
            conducaoSegura: [],
            paradaEstacionamento: [],
            checkedContents: [],

            fileCorrect: false,
            editFile: false,
            editContents: false,
            editHodo: false,
            editTime: false,
            sendData: false,

            aulas: [],
            conteudos: [],
            conteudosSelected: 0
        }
    },
    methods: {
        getFile(e) {
            this.aulas  =   []
            const file  = e.target.files[0];     

            this.inputFileLabel = e.target.files[0].name;

            this.getFileData(file, (response) => {
                this.aulas   =   JSON.parse(response)
            })
        },

        getFileData(file, callback) {
            const reader = new FileReader();

            reader.onload = e => callback(reader.result);

            reader.readAsText(file);
        },

        setData() {
            const file = this.dataInput
    
            if (this.selectedCFC.length < 1) {
                return this.launchToast('fa-exclamation ', 'Escolha uma auto escola.');
            }

            const schema = this.selectedCFC;

            const data = {
                contents: this.checkedContents,
                hodo_start: this.hodometro.hodoStart,
                hodo_end: this.hodometro.hodoEnd,
                begin_time: this.time.begin,
                finish_time: this.time.finish,
            }

            if (data.contents.length > 0) {
                file.contents = data.contents;
            }

            if (data.hodo_start.length > 0) {
                file.details.hodo_start = data.hodo_start;
            }

            if (data.hodo_end.length > 0) {
                file.details.hodo_end = data.hodo_end;
            }

            if (data.begin_time.length > 0) {
                file.details.begin_time = data.begin_time;
            }

            if (data.finish_time.length > 0) {
                file.details.finish_time = data.finish_time;
            }
    
            this.setAula(file, schema);
        },

        setAula() {
            this.sendData = true;

            this.$http.post(`${urlApi}/aulas/praticas/criar-aula`, this.aulas)
                .then(response => {
                    this.clear();
                    this.sendData = false;
                    this.launchToast('fa-check-circle ', response.data.mensagem);
                })
                .catch(error => {
                    this.sendData = false;
                    this.launchToast('fa-exclamation ', error.data.dados);
                })
        },

        getConteudos() {
            this.$http.get(`${urlApi}/aulas/praticas/consultar/conteudos`)
                .then(response => {
                    this.conteudos  =   Object.values(response.data.dados);

                }).catch(error => {
                    this.$toasted.show(error + ': Não foi possivel consultas os conteúdos na base de dados!');
                })
        },
        getConteudosFiltrados(plano_id) {
            if(plano_id > 0 && plano_id < 5)
            {
                return this.conteudos[plano_id];
            }else
            {
                this.$toasted.show('Selecione um conteúdo!');
                return []
            }
            // return this.conteudos.filter((conteudo) => {
            //     return conteudo.plano_id = plano_id
            // })
        },
        // getConteudos() {
        //     this.$http.get(`${urlApi}/aulas/praticas/consultar/conteudos`)
        //         .then(response => {
        //             const dados = response.data.dados;
        //             const planos = Object.keys(dados);

        //             planos.forEach(item => {
        //                 let text = '';

        //                 if (item == 1) {
        //                     text = 'Conceitos Basicos';
        //                 } else if (item == 2) {
        //                     text = 'Aprendendo a conduzir';
        //                 } else if (item == 3) {
        //                     text = 'Aprendizado da circulação';
        //                 } else if (item == 4) {
        //                     text = 'Condução segura';
        //                 } else if (item == 5) {
        //                     text = 'Parada e estacionamento';
        //                 }

        //                 this.selectContent.push({
        //                     value: item,
        //                     text: text
        //                 })
        //             })

        //             this.setPlanos(dados);
        //         })
        // },

        setPlanos(dados) {
            this.conceitosBasicos = dados[1];
            this.aprendendoAConduzir = dados[2];
            this.aprendizadoDaCirculacao = dados[3];
            this.conducaoSegura = dados[4];
            this.paradaEstacionamento = dados[5];
        },

        fileTypeValidation(data) {
            if (data.includes('contents') && data.includes('idClasses') && data.includes('begin_time') && data.includes('hodo_start')) {
                this.clearInputs();

                return true;
            }

            this.clearInputs();

            return false;
        },

        fileValidation(data) {
            if (data.details.id_anotacao_pratica > 0) {
                return this.launchToast('fa-exclamation ', 'Essa aula já foi sincronizada!');
            }

            this.messages = [];
            let messageContent = '';
            let messageHodo = '';
            let messageTime = '';

            this.clearInputs();
            this.fileCorrect = true;

            if (data.contents.length < 1) {
                this.editFile = true;
                this.editContents = true;
                this.fileCorrect = false;

                messageContent = 'Os conteúdos estão incompletos.';
                this.messages.push(messageContent);
            }

            if (data.details.hodo_start == null || data.details.hodo_start <= 0 || data.details.hodo_end == null || data.details.hodo_end <= 0) {
                this.editFile = true;
                this.editHodo = true;
                this.fileCorrect = false;

                this.hodometro.hodoStart = data.details.hodo_start;
                this.hodometro.hodoEnd = data.details.hodo_end;

                if (data.details.hodo_start.length > 0) {
                    this.hodometro.hodoStartDisabled = true;
                }

                if (data.details.hodo_end.length > 0) {
                    this.hodometro.hodoEndDisabled = true;
                }

                messageHodo = 'O hodômetro está incompleto.';
                this.messages.push(messageHodo);
            }

            if (data.details.begin_time.length < 19 || data.details.finish_time.length < 19) {
                this.editFile = true;
                this.editTime = true;
                this.fileCorrect = false;

                this.time.begin = data.details.begin_time;
                this.time.finish = data.details.finish_time;
       
                if (data.details.begin_time.length > 0) {
                    this.time.beginDisabled = true;
                }

                if (data.details.finish_time.length > 0) {
                    this.time.finishDisabled = true;
                }

                messageTime = 'O horário está incompleto.';
                this.messages.push(messageTime);
            }
        },

        clearInputs() {
            this.fileCorrect = false;
            this.editFile = false;
            this.editContents = false;
            this.editHodo = false;
            this.editTime = false;
        },

        clear() {
            this.dataInput = '';
            this.inputFileLabel = false;
            document.getElementById("formFile").value = "";
            this.clearInputs()
        },

        launchToast(icon, msg) {
            this.$toasted.show(msg, {
                icon: icon,
                position: 'top-right',
                duration: 5000,
                fullWidth: false
            })
        },

        updateHour(event, data) {
            if(event.target.value !== '')
            {
                let novaData = data.split(' ')[0] + ' ' + event.target.value;
                return novaData;
            }
            return data
        },

        statusColor(value) {
            return {
                'is-invalid': value == null || value == undefined || value == '' || value == 0,
                'is-valid': value !=  '',
            }
        }
    },
    created() {
        this.getConteudos();
    },
    watch: {
        selectedContent: {
            handler: function (val, oldVal) {
                this.checkedContents = [];
            },
            deep: true
        },
    }
}
</script>

<style scoped>
.label-file {
    color: #fff;
    background-color: #ffc20e;
    padding: 0.5em 2em;
    border: 2px solid #ffc20e;
    border-radius: 2em;
}

.label-file:hover {
    color: #ffc20e;
    background-color: #fff;
    padding: 0.5em 2em;
    cursor: pointer;
}

.font-button-modified {
    font-size: 0.9em;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 5px;
}

.message {
    font-size: 1.3em;
}

.footer {
    bottom: 0;
}
</style>
